// Compatibility layer for legacy code.
// New modules should import from `./http`, `./config` and `./logger` directly.
// This file preserves the pre-Phase-1 import surface used across pages.
import axios from "axios";
import { config } from "./config";
import { http, formatApiError as _formatApiError } from "./http";

const BACKEND_URL = config.backendUrl;
export const API = config.apiBaseUrl;

// Legacy alias for pages that still import { api } directly.
export const api = http;

// Legacy alias for the primary axios instance (some pages instantiate via axios.create).
export const legacyClient = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const formatMXN = (value) => {
  const n = Number(value || 0);
  return new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    maximumFractionDigits: 0,
  }).format(n);
};

export const formatApiError = _formatApiError;

export const imageUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  if (path.startsWith("/api/")) return `${BACKEND_URL}${path}`;
  return `${API}/files/${path}`;
};
